module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VTr6Uj/tc-custom/9781398451452.jpg?1705688052839",
      "alt": "This image is the cover for the book There's A Dragon Inside Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("There's A Dragon Inside Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“Do you have a dragon inside you?” Joey can’t see his dragon but he sure can feel him. Join Joey as he learns what anger feels and looks like and shares some simple battle tips to ‘help put the fire out’. Written by a psychologist in her mission to assist parents and children with early emotional literacy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melanie Hunter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Melanie is a psychologist with a special interest in children and adolescents. She often uses stories and characters to help her young clients make sense of hard topics. With a passion for facilitating growth of emotional literacy came the brainchild for her first book There’s A Dragon Inside Me. She hopes children and parents alike can use her book as a medium for discussion around anger, how it manifests and simple tips to assist. When she’s not working she’s wrangling her two young children at the beach or park or inhaling large amounts of coffee at the local coffee shop.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0